import { TMECHANIC_LOGIN_ACTIVITY, TRESPONSE_MECHANIC_DASHBOARD } from '@monorepo/types';

export type TMechanicDashboardState = {
  mechanicDashboardInfo: TMECHANIC_LOGIN_ACTIVITY[] | null;
};

export const TMechanicDashboardActionType = {
  GetMechanicDashboardInfo: 'GET_MECHANIC_DASHBOARD_INFO' as const,
  GetMechanicDashboardInfoSuccess: 'GET_MECHANIC_DASHBOARD_INFO_SUCCESS' as const,
  GetMechanicDashboardInfoFailure: 'GET_MECHANIC_DASHBOARD_INFO_FAILURE' as const,
};
